import Locale from "@/service/Locale/Locale";

export default new (class Price {
  getPrice(currencyCode: string, price: number) {
    try {
      // PAY-510 対応
      if (
        typeof Intl !== "undefined" &&
        typeof Intl.NumberFormat !== "undefined"
      ) {
        return Intl.NumberFormat(Locale.getLocale(), {
          style: "currency",
          currency: currencyCode,
        }).format(Number(price));
      }

      return String(price + " " + currencyCode);
    } catch (e) {
      return String(price + " " + currencyCode);
    }
  }
})();
